import React, { useState } from "react"
import { mutationRequest } from "../../util/request"
import { AlbumListItemShort } from "./AlbumListItemShort"
import { VideoListItemShort } from "./VideoListItemShort"
import { ConcertListItemShort } from "./ConcertListItemShort"
import { HeadlineListItemShort } from "./HeadlineListItemShort"
import { EditorialListItemShort } from "./EditorialListItemShort"
import type { AlbumDisplayConfig } from "../../types/albumDisplay"
import type { HeadlineDisplayConfig } from "../../types/headlineDisplay"
import type { VideoDisplayConfig } from "../../types/videoDisplay"
import type { ConcertDisplayConfig } from "../../types/concertDisplay"

interface PostListItemShortProps {
  post: any
  adminMode?: boolean
  albumConfig?: AlbumDisplayConfig
  headlineConfig?: HeadlineDisplayConfig
  videoConfig?: VideoDisplayConfig
  concertConfig?: ConcertDisplayConfig
}

const PostListItemShort = ({
  post: initialPost,
  adminMode = false,
  albumConfig,
  headlineConfig,
  videoConfig,
  concertConfig,
}: PostListItemShortProps) => {
  const [post, setPost] = useState(initialPost)

  const updateStatus = async () => {
    try {
      if (post.status === "published") {
        const response = await mutationRequest({
          path: `/api/v1/bands/${post.band_id}/posts/${post.id}`,
          options: { method: "DELETE" },
        })
        if (response.success) {
          setPost({ ...post })
        }
      } else {
        const response = await mutationRequest({
          path: `/api/v1/bands/${post.band_id}/posts/${post.id}`,
          options: { method: "PUT" },
          data: {
            post: { status: "published" },
          },
        })
        if (response.success) {
          setPost({ ...post })
        }
      }
    } catch (error) {
      console.error("ERROR: ", error)
    }
  }

  if (!post) return null

  const { post_type } = post

  let content: React.ReactNode = null

  if (post_type === "album") {
    content = (
      <AlbumListItemShort
        album={post}
        adminMode={adminMode}
        updateStatus={updateStatus}
        config={albumConfig}
      />
    )
  } else if (["song", "stand_alone_song", "link_song"].includes(post_type)) {
    content = (
      <AlbumListItemShort
        album={post}
        adminMode={adminMode}
        updateStatus={updateStatus}
        config={albumConfig}
      />
    )
  } else if (["youtube_video", "link_video"].includes(post_type)) {
    content = (
      <VideoListItemShort
        video={post}
        adminMode={adminMode}
        updateStatus={updateStatus}
        config={videoConfig}
      />
    )
  } else if (["concert", "event"].includes(post_type)) {
    content = (
      <ConcertListItemShort
        concert={post}
        adminMode={adminMode}
        updateStatus={updateStatus}
        config={concertConfig}
      />
    )
  } else if (["headline", "image_album", "link", "link_image"].includes(post_type)) {
    content = (
      <HeadlineListItemShort
        headline={post}
        adminMode={adminMode}
        updateStatus={updateStatus}
        config={headlineConfig}
      />
    )
  } else if (post_type === "bn_editorial") {
    content = (
      <EditorialListItemShort
        post={post}
        adminMode={adminMode}
        updateStatus={updateStatus}
        config={headlineConfig}
      />
    )
  } else {
    return null
  }

  return (
    <li id={post.id} data-post-type={post.post_type} className="mb-6">
      {content}
    </li>
  )
}

export default PostListItemShort
